export const INVITED_STATUS = 'INVITED';
export const USER_EXISTS_STATUS = 'USER_EXISTS';

export const SUCCESSFUL_INVITE_STATUSES = [INVITED_STATUS, USER_EXISTS_STATUS];
